import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import Task from "../../../../../model2/task/task"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"


export default class FieldTaskStartDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-start'
        this.label              = 'Start date'

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Task):boolean {
        return model.acl.canChangeStartDate
    }


    // Custom Methods

    tableCellOnValueChange = async (item: ItemModelV2, value:Moment|null, manager:TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const endStartDiff  = moment(item.task.endDate).diff(moment(item.task.startDate), 'days')
                const newStartDate  = value ? moment(value) : null
                const newEndDate    = value ? moment(value).add(endStartDiff,'days') : null

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                // item.task.setStartDateAndKeepCalendarDuration(value)

                item.task.updateStartDate(value, {keepCalendarDuration:true})
                item.task.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }



    }

}
